import React from 'react';
import styles from './QuickSearch.module.css';
import Settings from 'resources/settings';
import commonStrings from 'resources/commonStrings';
import { useAnalytics } from 'hooks/useAnalytics';

function QuickSearch() {
  const { handleItemClick, handleKeystroke } = useAnalytics('rlp-map-reports', 'navigate', 'student-quick-search');
  return (
    <div className={styles['container']}>
      <a
        className={styles['link']}
        href={`${Settings.ADMIN_BASE_PATH}/report/home/quickSearch`}
        aria-label={commonStrings.studentQuickSearch.title}
        onClick={handleItemClick}
        onKeyUp={handleKeystroke}
      >
        <div className={styles['header']}>
          <span>{commonStrings.studentQuickSearch.title}</span>
          <span className={styles['search-icon']}>search</span>
        </div>
        <p className={styles['description']}>{commonStrings.studentQuickSearch.description}</p>
      </a>
    </div>
  );
}

export default QuickSearch;
